import React from "react";
import styled, { css } from "styled-components";
import mq from "../../helpers/media-queries";

const El = styled.div`
	background: linear-gradient(
		64.01deg,
		#eaeaea 0.98%,
		rgba(234, 234, 234, 0.576065) 36.61%,
		rgba(234, 234, 234, 0) 85.02%
	);
	display: flex;
	height: 25vh;

	${(props) =>
		props.hideMobile &&
		css`
			${mq("sm", "max")} {
				display: none;
			}
		`}}
	${(props) =>
		props.fullHeight &&
		css`
			height: 100%;
		`}}

	${mq("sm", "min")} {
		width: 100%;
		height: 100%;
		justify-content: center;
		align-content: center;
	}

	img {
		max-width: 70%;
		max-height: 70%;
		align-self: center;
		margin: auto auto;
	}

	${(props) =>
		props.relative &&
		css`
			position: relative;
		`}
`;

const RenderContainer = ({ children, relative, hideMobile, fullHeight }) => {
	return (
		<El hideMobile={hideMobile} relative={relative} fullHeight={fullHeight}>
			{children}
		</El>
	);
};

export default RenderContainer;
